import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import Head from 'next/head';
import { EnPageLayout } from '@/components/en/pagelay';
import CountUp from 'react-countup';

interface IProps {

}

export default (props: any) => {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const width = window?.innerWidth
    setZoom(width > 580 ? 1 : 0.014 + width * 0.0017);
  }, []);

  return (
    <EnPageLayout>
      <div className={styles.container}>
        <div className={styles.intro}>
          <div className={styles.left}>
            <h2>Organic Festa Asia</h2>
            <div className={styles.info}>
              <p className={styles.site}>
                <span>Shanghai New International Expo Centre</span>
              </p>
              <p className={styles.time}>
                <span>Sept 3-5, 2025</span>
              </p>
            </div>
            <p>With the continuous improvement of residents' living standards, organic products, with their natural, pollution - free, and healthy characteristics, are gradually becoming a popular choice for consumption. Consumers' preference for organic products not only stems from their concern for their own health but also represents an active practice of the concepts of environmental protection and sustainable development. As a result, the global demand for organic products continues to rise, and the organic lifestyle is attracting more and more widespread attention.</p>
            <p>In recent years, China's organic industry has witnessed rapid growth. By 2023, the sales volume of China's organic industry had successfully exceeded the 100 - billion - yuan mark, and China has steadily ranked as the world's third - largest organic consumer market.</p>
            <p>The Organic Festa Asia has emerged and will meet you in Shanghai, China in 2025. This grand event aims to build a comprehensive platform integrating exhibition, communication, cooperation, and promotion, gathering high - quality resources from the global organic industry, and promoting the in - depth development of the organic industry in China, Asia, and even globally.</p>
            <p>We sincerely invite you to join this organic industry event full of opportunities and vitality, and jointly open a new chapter in the organic industry.</p>
            <div className={styles.sponsors}>
              <h3>Organizer</h3>
              <div>
                <div>
                  <img src="/image/sponsor1.png" alt="" />
                  <div>
                    <p>国际有机农业亚洲联盟</p>
                    <p>IFOAM-Organics Asia</p>
                  </div>
                </div>
                <div>
                  <img src="/image/sponsor2.png" alt="" />
                  <div>
                    <p>杜塞尔多夫展览（上海）有限公司</p>
                    <p>Messe Düsseldorf(Shanghai)Co.,Ltd.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.right} style={{ zoom }}>
            <div className={styles.leftDrop}>
              <div className={styles.dropBig}>
                <p>
                  <CountUp
                    end={13000}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>Visitors</span>
              </div>
              <div className={styles.dropSmall} style={{ marginRight: '15px' }}>
                <p>
                  <CountUp
                    end={300}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>Exhibiting<br />Enterprises</span>
              </div>
            </div>
            <div className={styles.rightDrop}>
              <div className={styles.dropSmall} style={{ marginLeft: '15px' }}>
                <p>
                  <CountUp
                    end={30}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>events</span>
              </div>
              <div className={styles.dropBig}>
                <p>
                  <CountUp
                    end={12000}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>㎡</span>
                </p>
                <span>Exhibition Area</span>
              </div>
              <div className={styles.dropSmall} style={{ margin: '-35px 0 0 -45px' }}>
                <p>
                  <CountUp
                    end={50}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>Activities<br />within the<br />Exhibition Year</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.photos}>
          <img src="/image/photo (1).png" alt="" />
          <img src="/image/photo (2).png" alt="" />
          <img src="/image/photo (3).png" alt="" />
          <img src="/image/photo (4).png" alt="" />
          <img src="/image/photo (5).png" alt="" />
          <img src="/image/photo (6).png" alt="" />
        </div>
      </div>
    </EnPageLayout>

  );
};


